import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { fuseAnimations } from '../../../../../../../core/animations';
import { SweetAlertService } from '../../../../../../services/sweet-alert/sweet-alert.service';
import { DivisionService } from '../../../../../../services/divisions/division.service';
import { SubjectService } from '../../../../../../services/subject/subject.service';
import { SchoolYearService } from '../../../../../../services/schoool-year/school-year.service';
import { ShiftService } from '../../../../../../services/shifts/shift.service';
import { EventService } from '../../../../../../services/events/event.service';
import { ReportService } from '../../../../../../services/reports/report.service';
import * as moment from 'moment';

@Component({
    selector: 'fuse-subject-schedule-dialog',
    templateUrl: './subject-schedule-dialog.component.html',
    styleUrls: ['./subject-schedule-dialog.component.scss'],
    animations: fuseAnimations
})
export class SubjectScheduleDialogComponent implements OnInit {
    @BlockUI('schedule-block') blockUI: NgBlockUI;

    divisions: any[] = [];
    subjects: any[] = [];
    shifts: any[] = [];
    
    selectedShift: any;
    selectedDivision: any;
    selectedSubject: any;
    
    selectedCharacter: any;
    characters: any[] = [
        { Id: 1, Name: 'Interino' },
        { Id: 2, Name: 'Suplente' }
    ];

    addedItems: any[] = [];
    currentSchoolYearId: number;

    constructor(
        public dialogRef: MatDialogRef<SubjectScheduleDialogComponent>,
        private sweetAlertService: SweetAlertService,
        private divisionService: DivisionService,
        private subjectService: SubjectService,
        private schoolYearService: SchoolYearService,
        private shiftService: ShiftService,
        private eventService: EventService,
        private reportService: ReportService
    ) {
    }

    ngOnInit(): void {
        this.loadData();
    }

    loadData(): void {
        this.blockUI.start('Cargando turnos...');
        this.schoolYearService.getAll().subscribe(schoolYears => {
            const activeYear = schoolYears.find(sy => sy.SchoolYearState.Id === 2);
            if (activeYear) {
                this.currentSchoolYearId = activeYear.Id;

                this.shiftService.getAll().subscribe(shifts => {
                    this.shifts = shifts;
                    this.blockUI.stop();
                }, error => {
                    this.blockUI.stop();
                    this.sweetAlertService.error('Error', 'No se pudieron cargar los turnos.');
                });
            } else {
                this.blockUI.stop();
                this.sweetAlertService.error('Error', 'No se encontró un año escolar activo.');
            }
        }, error => {
            this.blockUI.stop();
            this.sweetAlertService.error('Error', 'No se pudieron cargar los años escolares.');
        });
    }

    onShiftChange(shift: any): void {
        this.selectedDivision = null;
        this.selectedSubject = null;
        this.divisions = [];
        this.subjects = [];

        if (shift) {
            this.blockUI.start('Cargando cursos...');
            this.divisionService.getAllByShiftId(shift.Id, this.currentSchoolYearId).subscribe(divisions => {
                this.divisions = divisions.map(d => ({
                    ...d,
                    FullName: (d.CourseYearName || '') + ' ' + (d.DivisionName || '')
                }));
                this.blockUI.stop();
            }, error => {
                this.blockUI.stop();
            });
        }
    }

    onDivisionChange(division: any): void {
        this.selectedSubject = null;
        this.subjects = [];
        
        if (division) {
            this.blockUI.start('Cargando materias...');
            this.subjectService.getAllByDivisionLite(division.Id).subscribe((subjects: any) => {
                this.subjects = subjects.map(s => ({
                    SubjectId: s.SubjectId,
                    SubjectName: s.SubjectName
                }));
                this.blockUI.stop();
            }, error => {
                this.blockUI.stop();
            });
        }
    }

    addSubject(): void {
        if (!this.selectedDivision || !this.selectedSubject || !this.selectedCharacter) return;

        const exists = this.addedItems.find(item =>
            item.division.Id === this.selectedDivision.Id &&
            item.subject.SubjectId === this.selectedSubject.SubjectId
        );

        if (exists) {
            this.sweetAlertService.warning('Atención', 'Esta materia ya fue agregada para este curso.', null);
            return;
        }

        this.blockUI.start('Obteniendo horarios...');
        this.eventService.getScheduleByDivision(this.selectedDivision.Id).subscribe(events => {
            let scheduleItems = [];
            
            // Loop through all events (hora bloque)
            for (let e of events) {
                if (e.EventRepeats) {
                    for (let er of e.EventRepeats) {
                        if (er.Subjects) {
                            let matchSubject = er.Subjects.find(s => s.SubjectId === this.selectedSubject.SubjectId);
                            if (matchSubject) {
                                let start = moment(e.StartDate).format('HH:mm');
                                let end = moment(e.FinishDate).format('HH:mm');
                                scheduleItems.push({
                                    dayName: er.RepeatName || er.Name,
                                    title: e.Title,
                                    time: `de ${start} a ${end}`,
                                    startFull: e.StartDate
                                });
                            }
                        }
                    }
                }
            }

            // Group by day name
            let grouped = {};
            for (let item of scheduleItems) {
                if (!grouped[item.dayName]) {
                    grouped[item.dayName] = [];
                }
                grouped[item.dayName].push(item);
            }

            const dayOrder = ['Lunes', 'Martes', 'Miércoles', 'Miercoles', 'Jueves', 'Viernes', 'Sábado', 'Sabado', 'Domingo'];
            
            // Extract days present in grouped and sort them according to dayOrder
            let sortedDays = Object.keys(grouped).sort((a, b) => {
                let indexA = dayOrder.findIndex(d => a.toLowerCase().includes(d.toLowerCase()));
                let indexB = dayOrder.findIndex(d => b.toLowerCase().includes(d.toLowerCase()));
                if (indexA === -1) indexA = 99;
                if (indexB === -1) indexB = 99;
                return indexA - indexB;
            });

            let scheduleTextParts = [];
            for (let day of sortedDays) {
                // sort by start full
                grouped[day].sort((a, b) => new Date(a.startFull).getTime() - new Date(b.startFull).getTime());
                let parts = grouped[day].map(g => `${g.title} hora ${g.time}`).join(', ');
                scheduleTextParts.push(`- *${day}:* ${parts}`);
            }

            let scheduleText = scheduleTextParts.length > 0 ? scheduleTextParts.join('\n') : 'Sin horarios cargados';

            this.addedItems.push({
                division: {
                    Id: this.selectedDivision.Id,
                    FullName: this.selectedDivision.FullName,
                    CourseYearName: this.selectedDivision.CourseYearName,
                    DivisionName: this.selectedDivision.DivisionName
                },
                subject: {
                    SubjectId: this.selectedSubject.SubjectId,
                    SubjectName: this.selectedSubject.SubjectName
                },
                character: this.selectedCharacter.Name,
                shiftId: this.selectedShift.Id,
                shiftName: this.selectedShift.Description,
                scheduleText: scheduleText
            });

            this.blockUI.stop();
            this.selectedSubject = null;
            this.selectedCharacter = null;

        }, error => {
            this.blockUI.stop();
            this.sweetAlertService.error('Error', 'No se pudieron obtener los horarios.');
        });
    }

    removeItem(index: number): void {
        this.addedItems.splice(index, 1);
    }

    copySchedule(item: any): void {
        if (!item || !item.scheduleText || item.scheduleText === 'Sin horarios cargados') return;
        
        const template = `*Materia:* ${item.subject.SubjectName}
*Curso:* ${item.division.CourseYearName} ${item.division.DivisionName}
*Turno:* ${item.shiftName}
*Carácter:* ${item.character}

El Horario es el siguiente:
${item.scheduleText}`;

        const el = document.createElement('textarea');
        el.value = template;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        
        this.sweetAlertService.success('Copiado', 'El horario con formato ha sido copiado al portapapeles.', null);
    }

    generateSchedule(): void {
        if (this.addedItems.length === 0) return;

        const items = this.addedItems.map(item => ({
            DivisionId: item.division.Id,
            SubjectId: item.subject.SubjectId
        }));

        const payload = {
            Items: items
        };

        this.blockUI.start('Generando pdf de horarios...');

        // We will call SubjectSchedule which we need to implement in the backend
        this.reportService.subjectSchedule(payload).subscribe(blob => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const timestamp = new Date().getTime();
            link.download = `Horarios_Materias_${timestamp}.pdf`;
            link.click();
            window.URL.revokeObjectURL(url);
            this.blockUI.stop();
            //this.dialogRef.close();
        }, error => {
            //this.blockUI.stop();
            this.sweetAlertService.error('Error', 'No se pudo generar el horario pdf. Intente más tarde.', null);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/employees/components/subject-schedule-dialog/subject-schedule-dialog.component.ts